export const GET_ALL_USERS = 'GET_ALL_USERS'
export const addAllUsers = (data) => ({
  type: GET_ALL_USERS,
  payload: data,
})
